import Client from '@/client'

export default {
  list(offset, limit=20) {
    let query = `{id,uuid,name,application{name},dataset{name},owner{id,name},shape,status,updated_at}`;
    return Client.get(`predictions/`, { params: { limit: limit, offset: offset, query: query } });
  },
  create(payload) {
    return Client.post(`predictions/`, payload)
  },
  overwrite(id, payload) {
    return Client.post(`predictions/${id}/overwrite/`, { params: payload })
  },
  retrieve(id) {
    return Client.get(`predictions/${id}/`)
  },
  head(id, start = 0) {
    return Client.get(`predictions/${id}/head/`, { params: { start: start } })
  },
  info(id) {
    return Client.get(`predictions/${id}/info/`)
  },
  stats(id, column) { 
    return Client.get(`predictions/${id}/stats`, { params: { column: column }})
  },
  get_well(id, api) { 
    return Client.get(`predictions/${id}/get_well/`, { params: { api: api } })
  },
  set_well(id, payload) { 
    return Client.post(`predictions/${id}/set_well/`, payload)
  },
  share(id, payload) {
    return Client.post(`predictions/${id}/share/`, payload)
  },
  update(id, payload) {
    return Client.put(`predictions/${id}/`, payload)
  },
  patch(id, payload) {
    return Client.patch(`predictions/${id}/`, payload)
  },
  download(id) {
    return Client.get(`predictions/${id}/download/`)
  },
  dump(id) {
    return Client.get(`predictions/${id}/dump/`, { responseType: 'blob' })
  },
  clone(id, payload) {
    return Client.post(`predictions/${id}/clone/`, payload)
  },
  apis(id) {
    return Client.get(`predictions/${id}/apis/`)
  },
  destroy(id) {
    return Client.delete(`predictions/${id}/`)
  },
  delete(payload) {
    return Client.post(`predictions/delete/`, payload)
  },
  check_wells(payload) {
    return Client.post(`predictions/check_wells/`, payload)
  },
  identify_wells(payload) {
    return Client.post(`predictions/identify_wells/`, payload)
  },
  run_wizard(payload) {
    return Client.post(`predictions/run_wizard/`, payload)
  },
  sync_status(id) {
    return Client.post(`predictions/${id}/sync_status/`)
  },
  sync_groups(id) {
    return Client.post(`predictions/${id}/sync_groups/`)
  },
  decline_well(id, payload) {
    return Client.post(`predictions/${id}/decline_well/`, payload)
  }
}